import React from "react";
import { connect } from "react-redux";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import * as myConstClass from "../constant.js";
 import AgentAssistant from "../components/AgentAssistant";
// import HrDataAssistant from "../components/HrDataAssistant";
// import AgentAssistant from "../components/AiAssistant";
//import HrDataAssistant from "../components/HrAiChatWidget";
import {
  Translator,
  T,
  TF,
  LanguageList,
  Config
} from "react-translator-component";
Config.list = {
  KH: {
    text: "Khmer",
    icon: "../flags/de.svg",
    file: require("../locale/KH.js")
  },
  en: {
    text: "English",
    icon: "../flags/en.svg",
   file: require("../locale/en.js")
    //file:require(en)
  },
  ch: {
    text: "Chinese",
    icon: "../flags/en.svg",
    file: require("../locale/ch.js")
    
  },
 Mal: {
      text: "Malaysian",
      file: require("../locale/Mal.js"),
    },
  HI: {
    text: "Hindi",
    file: require("../locale/HI.js"),
  },
  TA: {
    text: "Tamil",
    file: require("../locale/TA.js"),
  },
};
Config.default = localStorage.getItem("lang");
//alert('in dashboard layout');
//localStorage.setItem('66', TF("{0}", T("Check In Out")));


///alert(TF("{0}", T("Check In Out")));

const pro_zone_logo_logo = myConstClass.SITE_URL + `img/White.png`;

const Dashboard = ({ sidebar, children }) => (
 
  <React.Fragment>
     <Translator>
    <Wrapper>
      {!sidebar.isOnRight && <Sidebar />}
      <Main>
        <Navbar />
        <Content>{children}</Content>
        <Footer />
        <div
          className="dashboard-bottom-logo"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px 0",
          }}
        >
          <img
            className="dashboar-plus-logo"
            src={pro_zone_logo_logo}
            style={{ width: "100px", height: "100px" }}
            alt="logo"
          />
        </div>
      </Main>
      {sidebar.isOnRight && <Sidebar />}
      {/* <AgentAssistant /> */}
      {/* <HrDataAssistant /> */}
      <AgentAssistant />
    </Wrapper>
    </Translator>
  </React.Fragment>
);

export default connect(store => ({
  sidebar: store.sidebar
}))(Dashboard);